import { DataListItem } from '@brighte/form-components';
import { ModifiedApplicationQuote } from '@graphql/types';
import { FINANCE_PURCHASE, formatDollars, productIds } from '@utils';
import { formatDollarsWithoutCents } from './getFinanceDetails';

function getFeesChargeDetails({ quote }: { quote?: ModifiedApplicationQuote }): DataListItem[] {
  if (!quote || !quote?.productConfiguration) return [];

  const { FINANCIAL_PRODUCT_FIELDS } = FINANCE_PURCHASE;

  const {
    financialProduct: { id },
    productConfiguration,
  } = quote;

  const { establishmentFee, weeklyAccountFee, latePaymentFee } = productConfiguration ?? {
    establishmentFee: 0,
    weeklyAccountFee: 0,
    latePaymentFee: 0,
  };

  const COMMON_FIELDS = {
    establishmentFee: {
      label: FINANCIAL_PRODUCT_FIELDS.establishmentFee,
      value: formatDollarsWithoutCents(establishmentFee),
    },
    weeklyAccountFee: {
      label: FINANCIAL_PRODUCT_FIELDS.weeklyAccountFee,
      value: formatDollars(weeklyAccountFee),
    },
    latePaymentFee: {
      label: FINANCIAL_PRODUCT_FIELDS.latePaymentFee,
      value: formatDollars(latePaymentFee),
    },
  };

  switch (id) {
    case productIds.BRIGHTE_PAY: {
      return [COMMON_FIELDS.weeklyAccountFee, COMMON_FIELDS.establishmentFee, COMMON_FIELDS.latePaymentFee];
    }
    default: {
      return [];
    }
  }
}

export default getFeesChargeDetails;
